import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import { ProctoringContext } from 'contexts';
import useCodingStore from './CodingStore';
import { AssessmentStates } from './constant';

const HEIGHT = '350px';

const sx = {
    container: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 0,
        flexShrink: 0,
    },
    videoContainer: {
        overflow: "hidden",
        height: HEIGHT,
        width: HEIGHT,
        borderRadius: '6px',
    },
};

function CameraPreview() {
    const {
        activateImageProctoring, deactivateImageProctoring, onCameraDisable
    } = React.useContext(ProctoringContext);

    const [loading, setLoading] = React.useState(false);
    const [enabled, setEnabled] = React.useState(true);

    const assessmentState = useCodingStore(state => state.assessmentState);

    const streamRef = React.useRef(null);
    const videoRef = useRef();

    const showComponent = React.useMemo(() => {
        return [
            AssessmentStates.SHOWING_TUTORIAL,
            AssessmentStates.RUNNING,
        ].includes(assessmentState);
    }, [assessmentState]);

    const toggleProctoring = (videoEnabled) => {
      if (assessmentState === AssessmentStates.RUNNING) {
        if (videoEnabled) {
          activateImageProctoring(
              300000, streamRef, videoRef
          ).catch(console.error);
        } else {
            deactivateImageProctoring(true);
        }
      }
    }

    React.useEffect(() => {
      if (!enabled) onCameraDisable();
    }, [enabled]);

    React.useEffect(() => {
      (async () => {
        if (enabled && showComponent) {
          setLoading(true);
          try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: true,
            });
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
            } else {
              streamRef.current?.getTracks()?.forEach((track) => {
                    track.stop();
                });
                setLoading(false);
            }
          } catch (error) {
            console.error(error);
            setEnabled(false);
            setLoading(false);
          }
        }else {
          streamRef.current?.getTracks()?.forEach((track) => {
              track.stop();
          });
          setLoading(false);
        }
        toggleProctoring(enabled);
      })();

      return () => {
          streamRef.current?.getTracks()?.forEach(function (track) {
              track.stop();
          });
          setLoading(false);
      }
    }, [enabled, showComponent]);

    return (
        <>
            <Box
                sx={sx.container}
                title="Click to toggle video"
            >
                <Box
                    sx={sx.videoContainer}
                    style={{ display: "block"}}
                    height={HEIGHT}
                >
                    <video
                        key={"video-on"}
                        playsInline
                        muted
                        onPlay={() => {
                            console.log('video-playing...');
                            setLoading(false);
                        }}
                        onError={() => { console.log('error') }}
                        ref={videoRef}
                        id="video"
                        style={{
                            display: loading ? "none" : "block",
                            width: `calc(${HEIGHT} * (25/10))`,
                            height: `calc(${HEIGHT} * (25/27))`,
                            marginLeft: `-85%`,
                            marginTop: `-20%`,
                            transform: "rotateY(180deg)",
                            WebkitTransform: "rotateY(180deg)",
                            MozTransform: "rotateY(180deg)",
                        }}
                    ></video>
                </Box>
            </Box>
        </>
    );
}

export default CameraPreview;